import type { DefaultTheme } from "simplydo/react/styled";

import type { UiPaletteKey } from "./uiPalette";

/** Named UI colours, plus open string for dynamic / custom values. */
export type UiColor = UiPaletteKey;

export function resolveUiColor(
  theme: DefaultTheme,
  color?: UiColor,
): string | undefined {
  if (!color) {
    return undefined;
  }
  return theme.colors[color as UiPaletteKey]?.ink;
}

/**
 * Resolve a surface colour for shadows (`against`): palette keys → `solid`,
 * otherwise treat the value as a CSS colour string.
 */
export function resolveSurfaceColor(
  theme: DefaultTheme,
  color?: UiColor,
): string | undefined {
  if (!color) {
    return undefined;
  }
  const palette = theme.colors[color as UiPaletteKey];
  if (palette) {
    return palette.solid;
  }
  return color;
}

export const SIZE_FONT = {
  small: "0.9rem",
  medium: "1rem",
  large: "1.1rem",
} as const;

/** Shared outer height for single-line buttons, inputs, and dropdowns. */
export const CONTROL_HEIGHT = {
  small: "28px",
  medium: "36px",
  large: "44px",
} as const;
